import React from 'react'

export const OrgContext = React.createContext({ isCurrentClub: null, currentMember: null })
